import { arrayToById, objectToById, arrayToByForeignId, objectToByForeignId, mergeByForeignId } from "redux/normalize";
import * as api from "api/api";
import { LeadNote, NewLeadNote } from "model/lead-note";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { loginReset } from "redux/slice/authentication";
import { LeadNoteResource } from "api/resource/lead-note";

export interface LeadNotesState {
	loading?: boolean;
	error?: string | null;
	byId: {
		[key: number]: LeadNoteResource;
	};
	byLeadId: {
		[key: number]: number[];
	};
};

const initialState: LeadNotesState = {
	byId: {},
	byLeadId: {},
};

const fetchLeadNotes = createAsyncThunk("leadNotes/fetchLeadNotes", async (payload, thunkAPI) => {
	thunkAPI.dispatch(leadNotesLoading());
	const result = api.getLeadNotes();
	result
		.then((leadNotes) => thunkAPI.dispatch(leadNotesLoaded(leadNotes)))
		.catch(error => thunkAPI.dispatch(leadNotesFailed(error)));
	return result;
});

const createLeadNote = createAsyncThunk("leadNotes/createLeadNote", async (payload: { leadNote: NewLeadNote }, thunkAPI) => {
	thunkAPI.dispatch(leadNotesLoading());
	const result = api.createLeadNote(payload.leadNote);
	result
		.then((leadNote) => thunkAPI.dispatch(leadNoteLoaded(leadNote)))
		.catch(error => thunkAPI.dispatch(leadNotesFailed(error)));
	return result;
});

const updateLeadNote = createAsyncThunk("leadNotes/updateLeadNote", async (payload: { leadNote: LeadNote }, thunkAPI) => {
	thunkAPI.dispatch(leadNotesLoading());
	const result = api.updateLeadNote(payload.leadNote);
	result
		.then((leadNote) => thunkAPI.dispatch(leadNoteLoaded(leadNote)))
		.catch(error => thunkAPI.dispatch(leadNotesFailed(error)));
	return result;
});

export const leadNotesSlice = createSlice({
	name: "leadNotes",
	initialState,
	reducers: {
		leadNotesLoading: (state) => {
			state.loading = true;
		},
		leadNotesLoaded: (state, action: PayloadAction<any[]>) => {
			state.loading = false;
			state.error = null;
			state.byId = arrayToById(action.payload, "id");
			state.byLeadId = arrayToByForeignId(action.payload, "id", "leadId");
		},
		leadNoteLoaded: (state, action: PayloadAction<any>) => {
			const byId = objectToById(action.payload, "id");
			const byLeadId = mergeByForeignId(state.byLeadId, objectToByForeignId(action.payload, "id", "leadId"));
			state.loading = false;
			state.error = null;
			state.byId = { 
				...state.byId,
				...byId
			};
			state.byLeadId = byLeadId;
		},
		leadNotesFailed: (state, action: PayloadAction<string>) => {
			state.loading = false;
			state.error = action.payload;
		},
		default: (state) => {
            return state;
        }
    },
    extraReducers(builder) {
		builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
    }
});

export const { leadNotesLoading, leadNotesLoaded, leadNoteLoaded, leadNotesFailed } = leadNotesSlice.actions;
export { fetchLeadNotes, createLeadNote, updateLeadNote };